import { useMemo } from 'react';
import { useActiveAddons } from './useBilling';

/** Derived feature flags for the UI. Mirrors worker/src/lib/features.ts
 *  so components can disable controls the backend would reject anyway —
 *  cheaper + clearer than waiting for a 403. Truth is still the worker;
 *  this is just an optimistic check based on the addon list. */
export type UiFeatures = {
  byok: boolean;
  long_articles: boolean;
  web_grounding: boolean;
  api: boolean;
  max_sites: number;
  team_editors: number;
  isLoading: boolean;
};

const BASE_SITES = 1;
const BASE_EDITORS = 0;

export function useFeatures(): UiFeatures {
  const { data, isPending } = useActiveAddons();
  return useMemo<UiFeatures>(() => {
    const addons = data?.addons ?? [];
    let extraSites = 0;
    let extraEditors = 0;
    let byok = false;
    let longArticles = false;
    let webGrounding = false;
    let api = false;
    for (const a of addons) {
      switch (a.addon_type) {
        case 'extra_site': extraSites++; break;
        case 'extra_editor': extraEditors++; break;
        case 'byok': byok = true; break;
        case 'long_articles': longArticles = true; break;
        case 'web_grounding': webGrounding = true; break;
        case 'api_access': api = true; break;
      }
    }
    return {
      byok,
      long_articles: longArticles,
      web_grounding: webGrounding,
      api,
      max_sites: BASE_SITES + extraSites,
      team_editors: BASE_EDITORS + extraEditors,
      isLoading: isPending,
    };
  }, [data, isPending]);
}
